import { useState, useEffect } from "react";
import NiceModal from '@ebay/nice-modal-react';
import Icons from "/src/features/phone/data/types/Icons";
import "../DashboardVariable.css";
import '/src/components/UI/Button/IconButton/IconButton.css'
import ButtonAction from "/src/components/UI/Button/Button";
import DashboardButtonConfirmationModal from "./DashboardButtonConfirmationModal"
import { useToastDispatchContext } from '/src/layouts/toast/context/toastContext';
import dashboardService from "../../../../services/dashboardService";

function DashboardButton({ data, bot, dashboardsChannelsLinks }) {
    const { loadBotBlock } = dashboardService;
    const toast = useToastDispatchContext();

    let channels = dashboardsChannelsLinks.map((link) => {
        return {
            value: link.channel.key,
            text: <div style={{display: "flex", alignItems: "center"}}> <img srcSet={Icons[link.channel.type.name]}></img>
                {link.channel.name}</div>
        }
    })
    let hasModal = data.regex != null || channels.length > 1;
    const loadButton = () => {
        if (hasModal) {
            showConfirmationMessage();
            return;
        }
        else if (channels.length == 1){
            onSubmit(channels[0].value)
            return;
        }
        toast.error('Error', 'The dashboard is not linked to any channel',4000);
    }
    const showConfirmationMessage = () => {
        NiceModal.show(DashboardButtonConfirmationModal, {
            data: data,
            postbackAction: onSubmit,
            channels: channels
        })
    }

    const onSubmit = async (channel_key) => {
        const result = await loadBotBlock({ tracking: data.value }, bot.company.name, bot.id,channel_key);
        if (hasModal == false) {
            toast.success('Success', 'The action has been done');
        }
        if (!result) return;
        return result;
    };
    return (
        <div>
            <ButtonAction id={data.id} style={{ marginTop: "15px" }} label={data.default_value} onClick={loadButton} defaultChoice={data.value} setValue={(name, value) => saveData(value)}></ButtonAction>
        </div>
    );
}

export default DashboardButton;